import * as React from 'react';

import Button from 'components/ButtonDeprecated';
import EventTracking from 'lib/EventTracking';
import Glyph from 'components/Glyph';
import LayerTrigger from 'components/LayerTrigger';
import MediaObject from 'components/MediaObject';
import Menu from 'components/Menu';
// @ts-ignore
import TargetFilterMenuItem from 'chat_v2/components/TargetFilterMenuItem';

import AppleImage from 'assets/images/roles/teacher.svg';
import BellImage from 'assets/images/bell.svg';
import HeartImage from 'assets/images/roles/parent.svg';
import PencilImage from 'assets/images/roles/student.svg';
import EveryoneImage from 'assets/images/roles/everyone.svg';

import { ComposerRecipients_composerRecipients_recipients_ComposerRecipientListEntity, ComposerRecipients_composerRecipients_recipients_ComposerRecipientListEntity_recipient_filters, ComposerRecipients_composerRecipients_recipients_ComposerRecipientListEntity_recipient_filters_values } from 'chat_v2/components/SplitComposer/queries/__generated__/ComposerRecipients';
import { ComposerStateContext, ComposerDispatchContext } from 'chat_v2/ComposerContext';

type Props = {
  filter: ComposerRecipients_composerRecipients_recipients_ComposerRecipientListEntity_recipient_filters,
  entity: ComposerRecipients_composerRecipients_recipients_ComposerRecipientListEntity,
  dataTestSelector?: string,
  recipientIsSelected: boolean,
};

type State = {
  menuIsOpen: boolean,
};

const roleToIcon: { [role: string]: string } = {
  student: PencilImage,
  parent: HeartImage,
  teacher: AppleImage,
  admin: BellImage,
};

export default class TargetFilterMenu extends React.Component<Props, State> {
  state = {
    menuIsOpen: false,
  };
  
  renderFilterMenu = (filterType: string, filterValues: ComposerRecipients_composerRecipients_recipients_ComposerRecipientListEntity_recipient_filters_values[]) => {
    const { recipient } = this.props.entity;
    const uuidProp = recipient.type === 'group' ? { groupUuid: recipient.uuid } : { orgUuid: recipient.uuid };
    return (
      <Menu className="RecipientItem-menu" hideOnSelect={false}>
        <ComposerStateContext.Consumer>
          {composerState =>
            <ComposerDispatchContext.Consumer>
              {composerDispatch =>
                <>
                  <TargetFilterMenuItem
                    filter={{ type: filterType, value: { id: 'all', label: 'Everyone' }}}
                    imageSrc={EveryoneImage}
                    isSelected={false}
                    onClick={() => { /* TODO */ }}
                    {...uuidProp}
                  />
                  {filterValues.map(value => {
                    const isSelected = ((composerState.filters[recipient.uuid] || {})[filterType] || []).includes(value.key);
                    return (
                      <TargetFilterMenuItem
                        key={value.key}
                        filter={{ type: filterType, value: { id: value.key, label: value.label }}}
                        imageSrc={roleToIcon[value.key]}
                        isSelected={isSelected}
                        dataTestSelector={this.props.dataTestSelector}
                        onClick={() => composerDispatch({ type: isSelected ? 'removeFilter' : 'addFilter', recipientUuid: recipient.uuid, filterType, filterValue: value.key })}
                        {...uuidProp}
                      />
                    )
                    })}
                </>
              }
            </ComposerDispatchContext.Consumer>
          }
        </ComposerStateContext.Consumer>
      </Menu>
    );
  };

  toggleMenu = (event: React.MouseEvent) => {
    event.stopPropagation();
    (this.refs.trigger as LayerTrigger).toggleLayer();
  };

  render() {
    const { filter } = this.props;
    const numberOfSelectedFilters = 0; // TODO
    const selectedFilterText = ''; // TODO

    const setMenuIsOpen = (menuIsOpen: boolean) => {
      this.setState({ menuIsOpen });
      EventTracking.trackKey(`announcements.share_to.refine_recipients.role.${menuIsOpen ? 'close' : 'open'}`);
    }

    return (
      <LayerTrigger
        ref="trigger"
        trigger="manual"
        hideLayerOnScroll
        layer={this.renderFilterMenu(filter.key, filter.values)}
        placement="bottom"
        alignment="left"
        onHide={() => setMenuIsOpen(false)}
        onShow={() => setMenuIsOpen(true)}>
        <Button
          onClick={this.toggleMenu}
          size="xxxsmall"
          color={this.state.menuIsOpen ? 'mascot' : 'paper'}
          weight="normal"
          data-test-selector={this.props.dataTestSelector}
          className="RecipientItem-button">
          <MediaObject inline figure="right" gutter="xsmall">
            {'Everyone' /* TODO */}
            <Glyph name="chevron-down" size="xxsmall" solo />
          </MediaObject>
        </Button>
      </LayerTrigger>
    );
  }
}
